<script lang="ts">
  import Spacer from "@/components/spacer.svelte";
  import Subnav from "@/views/bandiburri/subnav.svelte";
  import { Route } from "svelte-router-spa";
  import { Container } from "sveltestrap";

  export let currentRoute;
  export let params;
</script>

<Route {currentRoute} {params} />
<Subnav {currentRoute} />

<Container>
  <div class="mainview">
    <Spacer size="3rem" />
    <div class="com_awrad">
      <img
        src="/images/bandiburri/award/award_main.png"
        alt="메인"
        style="width: 100%;"
      />
    </div>
    <Spacer size="4rem" />
    <div class="section_1">
      <div class="section">
        <div>주요수상</div>
      </div>
    </div>

    <Spacer size="3.7rem" />
    <div class="com_award">
      <img
        class="award_img"
        src="/images/bandiburri/award/award1.jpg"
        alt="수상내역1"
      />
    </div>

    <Spacer size="6rem" />
    <div class="com_award">
      <img
        class="award_img"
        src="/images/bandiburri/award/award2.jpg"
        style="width: 96%;"
        alt="수상내역2"
      />
    </div>

    <Spacer size="5rem" />
    <div class="section_2">
      <div class="section">
        <div>특허증</div>
      </div>

      <Spacer size="3.7rem" />
      <div class="com_award">
        <img
          class="award_img"
          src="/images/bandiburri/award/award3.jpg"
          alt="특허권"
        />
      </div>
    </div>

    <Spacer size="2em" />
    <div class="section_3">
      <div class="section">
        <div>인증관련</div>
      </div>

      <Spacer size="1.7rem" />
      <div class="com_award">
        <img
          class="award_img"
          src="/images/bandiburri/award/award4.jpg"
          style=""
          alt="인증관련"
        />
      </div>
    </div>
  </div>
</Container>

<style lang="scss">
  .award_img {
    display: block;
    margin: auto;
  }
  .section {
    font-size: 1.2rem;
    font-weight: 600;
    border-bottom: 1px solid #5c3327;
    color: #5c3327;
  }
  .section > div {
    padding: 0.5rem;
  }
</style>
